import { SocialLinks } from './components/SocialLinks'
import { FooterMenu } from './components/FooterMenu'
import { Link as RemixLink } from '@remix-run/react'
import { MainLogoIcon } from '../icons/logos'

export const Footer = () => {
  const currentYear = new Date().getFullYear()
  return (
    <footer className="px-6 md:px-10 pb-4">
      <div className="flex justify-between flex-col py-8 gap-5 xl:gap-1 lg:flex-row max-xl:justify-start max-md:gap-0 max-md:py-10">
        <div className="flex flex-col items-center xl:items-start xl:w-1/3 max-xl:flex-col max-xl:gap-6">
          <RemixLink to="/" className="block w-40 max-xl:w-36 max-lg:w-32 max-md:mb-10">
            <MainLogoIcon />
          </RemixLink>
          <div className="hidden lg:flex flex-col justify-end flex-1 h-full">
            <SocialLinks />
          </div>
        </div>
        <FooterMenu />
        <div className="flex justify-center w-full lg:hidden">
          <SocialLinks />
        </div>
      </div>
      <div className="flex items-center justify-between text-neutral-80 max-xl:flex-wrap">
        <div className="text-xs text-right flex-grow text-neutral-60 pt-2 max-xl:w-full max-xl:mt-4 max-xl:pt-4 max-xl:text-center max-md:text-center max-md:mt-4 max-md:pt-4 border-t border-neutral-80">
          © {currentYear} Career.io. All Rights Reserved
        </div>
      </div>
    </footer>
  )
}
